import SocialLinks from './SocialLinks.js';
const Footer =()=>{
    return(
        <div><br/><br/><br/>
            <footer className="bg-dark p-1 fixed-bottom">
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <p className="text-custom text-small mt-3">
                                <i className="bi bi-c-circle"></i> 2023  Norrenberger. All Rights Reserved
                            </p>
                        </div>
                        <div className="col text-end">
                            <SocialLinks/>
                        </div>
                    </div>
                </div>
               
            </footer>
        </div>
    )
}
export default Footer;